
        export * from 'axe-core/axe.js';
        export * as default from 'axe-core/axe.js'
        